export const DOCUMENT_TYPES = {
  IDENTITY_ID: 1,
  TAX_ID: 2,
} as const

export type DocumentTypeKeys = keyof typeof DOCUMENT_TYPES
export type DocumentTypeValues = (typeof DOCUMENT_TYPES)[DocumentTypeKeys]

export const DOCUMENT_VARIANTS = {
  // Document Categories
  IDENTITY_DRIVERS_LICENSE: 1,
  IDENTITY_ID_CARD: 2,
  IDENTITY_PASSPORT: 3,
  IDENTITY_RESIDENCY_PERMIT_CARD: 4,
  IDENTITY_TEMPORARY_VISA: 5,
  IDENTITY_BIRTH_CERTIFICATE: 6,
  IDENTITY_PAPER_PASSPORT: 8,
  IDENTITY_OTHER: 9,

  // Tax Documents
  TAX_FORM_1040: 7,
  TAX_W2: 10,
  TAX_FORM_1099: 11,
  TAX_NON_TAXABLE: 16,

  // Benefits Documents
  BENEFITS_SOCIAL_SECURITY_AWARD_LETTER: 12,
  BENEFITS_DISABILITY_BENEFITS_LETTER: 13,
  BENEFITS_CHILD_SUPPORT_PAYMENTS: 14,
  BENEFITS_ALIMONY_PAYMENTS: 15,
} as const

export type DocumentVariantKeys = keyof typeof DOCUMENT_VARIANTS
export type DocumentVariantValues =
  (typeof DOCUMENT_VARIANTS)[DocumentVariantKeys]
